module.exports = __webpack_public_path__ + "static/media/PrivateEvent.c0a5ca8e.png";